/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Edu_Agent_Abilities_BlurbInputs */



/**
* | output |
* | --- |
* | "Abilities are what your agent can do beyond reading, such as searching the web or working with a connected tool. Leave them all on, or pick only the groups t..." |
*
* @param {Uno_Edu_Agent_Abilities_BlurbInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_edu_agent_abilities_blurb = /** @type {((inputs?: Uno_Edu_Agent_Abilities_BlurbInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Edu_Agent_Abilities_BlurbInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Fähigkeiten sind das, was Ihr Agent über das Lesen hinaus kann, etwa im Web suchen oder mit einem verbundenen Werkzeug arbeiten. Lassen Sie alle an oder wählen Sie nur die Gruppen, die die Aufgabe braucht.")
	return /** @type {LocalizedString} */ ("Abilities are what your agent can do beyond reading, such as searching the web or working with a connected tool. Leave them all on, or pick only the groups the job needs.")
});